import { useTranslation } from '@dagens/frontend-i18n';
import styled from 'styled-components';
import { Button } from '@dagens/carrot';
import { useState } from 'react';
import DeferChangeHOC from '_common/components/defer-change-hoc/DeferChangeHOC';
import InputWithLabel from '_common/components/input/InputWithLabel';
import SectionHOC from '_common/components/section-hoc/SectionHOC';

const MaxWidthContainer = styled.div`
  width: 100%;
  max-width: 490px;
`;

const DeferredInputWithLabel = DeferChangeHOC(InputWithLabel);

type ProfileAccessTokenSectionProps = {
  accessToken?: string;
  onGenerate: () => void;
  isGenerating: boolean;
};

const ProfileAccessTokenSection = ({
  accessToken,
  onGenerate,
  isGenerating
}: ProfileAccessTokenSectionProps) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(accessToken ?? '');
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1000);
  };

  return (
    <MaxWidthContainer id="access-token-section">
      {accessToken && (
        <div
          className={`
            flex
            items-end
            justify-between
            gap-m
          `}
        >
          <div className="flex-1">
            <DeferredInputWithLabel
              labelText={t('producer:AccessTokenLabelText')}
              placeholder={t('producer:AccessTokenPlaceholder')}
              value={accessToken}
              type="password"
              disabled
            />
          </div>
          <div className="mb-[28px]">
            <Button variant="primary" size="regular" onClick={handleCopy}>
              {isCopied
                ? t('producer:AccessTokenCopied')
                : t('producer:AccessTokenCopy')}
            </Button>
          </div>
        </div>
      )}

      {!accessToken && (
        <div>
          <Button variant="primary" size="regular" onClick={onGenerate}>
            {isGenerating
              ? t('producer:AccessTokenGenerating')
              : t('producer:AccessTokenGenerate')}
          </Button>
        </div>
      )}
    </MaxWidthContainer>
  );
};

export default SectionHOC(ProfileAccessTokenSection);
